import { Box, Grid, Button } from "@mui/material";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { EditNotificationsOutlined } from "@mui/icons-material";
import { WidgetComponentMaps } from "../../../common/WidgetComponentMaps";
import { filledButton } from "../../../ui/styles/buttonStyles";
import OrganizationReminders from "./OrganizationReminders";

export const ServicesReminder = ({ swapyName = "servicesWidget", sx }) => {
  return (
    <WidgetComponentMaps
      swapyName={swapyName}
      title="Organization Reminders"
      description=" Set the advance notification time for scheduled events. The system will automatically send reminders once the configured interval is reached."
      icon={<EditNotificationsOutlined />}
      sxProp={{
        ...sx,
        height: { xs: "400px", md: "450px", lg: "100%" },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flex: 1 }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          bgcolor: "transparent",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
          <BaseModalComponent
            modalKey="Organization-Reminders"
            modalLabel="Manage Reminders"
            elementTrigger={<Button sx={filledButton}>Manage notification</Button>}
            onCloseTheme="color"
          >
            <OrganizationReminders />
          </BaseModalComponent>
        </Box>
      </Box>
    </WidgetComponentMaps>
  );
};
